import { Injectable } from '@angular/core';
import { Swiper } from 'swiper';

@Injectable({
  providedIn: 'root'
})
export class SwiperService {

  private swiperInstances: Swiper[] = [];

  constructor() { }

  initSwipers(): void {
    // Initialize testimonial swiper
    this.initTestimonialSwiper();
    
    // Initialize marquee swipers
    this.initMarqueeSwipers();
  }

  initTestimonialSwiper(): void {
    const testimonialElement = document.querySelector('.myTestimonialSwiper');
    if (testimonialElement) {
      const swiper = new Swiper('.myTestimonialSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          }
        }
      });
      this.swiperInstances.push(swiper);
    }
  }

  initMarqueeSwipers(): void {
    const marqueeElements = document.querySelectorAll('[data-slider-options]');
    marqueeElements.forEach((element: Element) => {
      const optionsAttr = element.getAttribute('data-slider-options');
      if (optionsAttr) {
        try {
          const options = JSON.parse(optionsAttr);
          // Ensure autoplay is properly configured
          if (options.autoplay && typeof options.autoplay === 'object') {
            options.autoplay = {
              ...options.autoplay,
              disableOnInteraction: options.autoplay.disableOnInteraction !== undefined 
                ? options.autoplay.disableOnInteraction 
                : false
            };
          }
          const swiper = new Swiper(element as HTMLElement, {
            ...options,
            modules: []
          });
          this.swiperInstances.push(swiper);
        } catch (e) {
          console.error('Error parsing swiper options:', e);
        }
      }
    });
  }

  destroySwipers(): void {
    this.swiperInstances.forEach(swiper => {
      if (swiper && swiper.destroy) {
        swiper.destroy();
      }
    });
    this.swiperInstances = [];
  }
}

